import { render } from "./StepComplete.vue?vue&type=template&id=23456af5"
import script from "./StepComplete.vue?vue&type=script&lang=js"
export * from "./StepComplete.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src689428801/src/mess-barcode-scan-req-serv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__